import { AxiosInstance } from 'axios';

import { insertId } from '../insertId';
import { toResponse } from '../genericToResponse';
import { cancellable } from '../cancellable';

export default (api: AxiosInstance, url: string) => (marketId: number) => {
  const urlWithId = insertId(url, marketId);
  return cancellable<any>(
    (cancelOptions: any) => api.get(urlWithId, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/linkUpload/getTemplates.ts